import { useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { queriesInternalAccounts, queriesTaxWithholdings } from "@query";
import { selectorTaxWithholdingAccount } from "../../../shared/selectors/selectorTaxWithholdingAccount";
import { PATH_ONBOARDING_TAX_WITHHOLDINGS } from "../../Onboarding";
import { useModalTurnOn } from "../modals/ModalTurnOn";
import { PATH_TAX_WITHHOLDINGS_SURVEY } from "../paths";

export function useTaxWithholdingsStatus() {
  const history = useHistory();

  const querySettings =
    queriesTaxWithholdings.getTaxWithholdingSettings.useQuery();
  const queryInternalAccounts =
    queriesInternalAccounts.listInternalAccounts.useQuery();
  const [update, updateMeta] =
    queriesTaxWithholdings.updateTaxWithholdingSettings.useMutation();

  const modalTurnOn = useModalTurnOn();

  const isActive = useMemo(
    () => querySettings.data?.isEnabled === true,
    [querySettings.data?.isEnabled]
  );

  const rate = useMemo(
    () => querySettings.data?.withholdingRate,
    [querySettings.data?.withholdingRate]
  );

  const taxWithholdingAccount = useMemo(() => {
    return queryInternalAccounts.data?.data?.find(
      selectorTaxWithholdingAccount
    );
  }, [queryInternalAccounts.data]);

  const shouldCompleteSetup = useMemo(
    () => !taxWithholdingAccount || !rate,
    [taxWithholdingAccount, rate]
  );

  const turnOn = useCallback(async () => {
    if (shouldCompleteSetup) {
      history.push(PATH_ONBOARDING_TAX_WITHHOLDINGS);
      return;
    }

    modalTurnOn.open({
      onClose: result => {
        if (!result) {
          return;
        }

        update({
          taxWithholdingSettingsUpdate: { isEnabled: true }
        });
      }
    });
  }, [history, modalTurnOn, shouldCompleteSetup, update]);

  const turnOff = useCallback(() => {
    update(
      {
        taxWithholdingSettingsUpdate: { isEnabled: false }
      },
      {
        onSuccess: () => {
          history.push(PATH_TAX_WITHHOLDINGS_SURVEY);
        }
      }
    );
  }, [history, update]);

  return {
    isActive,
    rate,
    taxWithholdingAccount,
    shouldCompleteSetup,
    updateMeta,
    turnOn,
    turnOff
  };
}
